"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../Common/CommonBaseError");
exports.SessionFactoryErrorName = "SessionFactoryErrorName";
class SessionFactoryError extends CommonBaseError_1.CommonBaseError {
}
exports.SessionFactoryError = SessionFactoryError;
//# sourceMappingURL=ISessionFactory.js.map